module.exports = __webpack_public_path__ + "static/media/FailureCheckBox.5c271706.svg";